import type { Stripe, StripeError } from '@stripe/stripe-js';

import type { TrackingFn } from '@change-corgi/core-react/tracking';

export async function confirmStripeCardPayment(
	stripe: Stripe,
	paymentMethod: string | undefined,
	clientSecret: string,
	trackEvent?: TrackingFn,
): Promise<StripeError | undefined> {
	const { error, paymentIntent } = await stripe.confirmCardPayment(
		clientSecret,
		{
			payment_method: paymentMethod,
		},
		{ handleActions: false },
	);

	if (error) {
		return error;
	}

	if (paymentIntent.status === 'requires_action') {
		void trackEvent?.('pp_payment_authentication_challenge');
		const { error: actionError } = await stripe.handleNextAction({
			clientSecret,
		});
		if (actionError) {
			void trackEvent?.('pp_payment_authentication_failure');
		} else {
			void trackEvent?.('pp_payment_authentication_success');
		}
		return actionError;
	}
	return undefined;
}
